module.exports = __webpack_public_path__ + "static/media/baristacaffecrema.7c8ebf47.jpg";